import { useCallback, useEffect, useState } from 'react';
import { useMe } from '@/lib/auth';
import type { WorkspaceSummary } from '@/lib/types';

const KEY = 'lumo-ws';

/** Текущий воркспейс дашборда (запоминается в localStorage). */
export function useCurrentWorkspace(): { workspaces: WorkspaceSummary[]; current: WorkspaceSummary | null; select: (id: string) => void } {
  const me = useMe();
  const workspaces = me.data?.workspaces ?? [];
  const [id, setId] = useState<string | null>(() => {
    try {
      return localStorage.getItem(KEY);
    } catch {
      return null;
    }
  });
  const current = workspaces.find((w) => w.id === id) ?? workspaces.find((w) => w.personal) ?? workspaces[0] ?? null;
  useEffect(() => {
    if (current && current.id !== id) setId(current.id);
  }, [current, id]);
  const select = useCallback((next: string) => {
    setId(next);
    try {
      localStorage.setItem(KEY, next);
    } catch {
      /* ignore */
    }
  }, []);
  return { workspaces, current, select };
}
